/** @jsx jsx */
import { jsx } from '@compiled/react';
import Lozenge from '@atlaskit/lozenge';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../messages.tsx';
import { useCommentContext } from './CommentContextProvider.tsx';

const CommentLozenge = () => {
	const { formatMessage } = useIntl();

	const { showLozenge, isDeleted } = useCommentContext();

	if (isDeleted || !showLozenge) {
		return null;
	}

	return <Lozenge appearance="default">{formatMessage(messages.lozenge)}</Lozenge>;
};
export default CommentLozenge;
